'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002emain from "./samples.main.js";
var $p;
$j_samples$002emain.$s_Lsamples_main__main__AT__V(new ($j_java$002elang$002e$002dObject.$d_T.r().C)([]));
